import React, { useEffect, useState } from 'react';
import { ModalBase } from '@bynder/design-system';

import { GroupRemoveConfirmation } from './ModalRemoveConfirm';
import { Group, Page } from './types';
import { GroupDetails } from './GroupDetails';
import { API } from './helpers';
import { GroupsList } from './GroupsList';
import { useCustomEvent } from '../../helpers/useCustomEvent';

export function WFGroupsModal() {
	const [isOpen, setIsOpen] = useState(false);
	const [modalPage, setModalPage] = useState<Page>('groups');
	const [removeConfirmIsOpen, setRemoveConfirmIsOpen] = useState(false);
	const [groups, setGroups] = useState<Group[]>([]);
	const [groupToModify, setGroupToModify] = useState<Group>();
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		if (isOpen) {
			setGroups([]);
			setModalPage('groups');
			fetchGroups();
		}
	}, [isOpen]);

	useCustomEvent('openWFGroupsModal', openModal);

	function openModal() {
		setIsOpen(true);
	}

	function closeModal() {
		setIsOpen(false);
	}

	async function fetchGroups() {
		setIsLoading(true);
		const response = await API.listGroups();
		setIsLoading(false);
		setGroups(response);
	}

	function onRemove(event: React.MouseEvent<HTMLElement, MouseEvent>, group: Group) {
		event.stopPropagation();
		setGroupToModify(group);
		setRemoveConfirmIsOpen(true);
	}

	function onConfirmRemove(confirmed?: boolean) {
		if (confirmed) {
			setGroups((current) => current.filter((group) => group.id !== groupToModify?.id));
		}

		setRemoveConfirmIsOpen(false);
		setGroupToModify(undefined);
	}

	function editGroup(group: Group) {
		setGroupToModify(group);
		setModalPage('edit');
	}

	function goBack() {
		setModalPage('groups');
		setGroups([]);
		fetchGroups();
	}

	return (
		<>
			<ModalBase isOpen={isOpen} onClose={closeModal} size="small">
				{modalPage === 'groups' && (
					<GroupsList
						isLoading={isLoading}
						groups={groups}
						editGroup={editGroup}
						onRemove={onRemove}
						setModalPage={setModalPage}
						closeModal={closeModal}
					/>
				)}
				{modalPage === 'add' && <GroupDetails mode="add" goBack={goBack} />}
				{modalPage === 'edit' && (
					<GroupDetails mode="edit" groupId={groupToModify?.id} goBack={goBack} />
				)}
			</ModalBase>
			<GroupRemoveConfirmation
				group={groupToModify}
				isOpen={removeConfirmIsOpen}
				onConfirm={onConfirmRemove}
			/>
		</>
	);
}
